import { AuthSession } from "aws-amplify/auth";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { Config } from "atoms/Rtool/newConfigAtoms";
import type { Powertrain } from "atoms/powertrainAtom";

type UploadResult = { bucket: string; path: string; etag?: string | undefined };

// S3 キー最上位は <powertrain>（HEV対応S3設計 §2）。HEV は calculation_id の直後に gear_id を挿入する（§3.2）。
export const uploadExcelToS3 = async (
    authSession: AuthSession | null,
    file: File,
    config: Config,
    drive_mode_id: string,
    phenomenon_id: string,
    powertrain: Powertrain = "bev",
    gear_id?: string,
): Promise<UploadResult> => {
    const BUCKET =
        process.env.REACT_APP_BUCKET ||
        `pt-nvh-r-data-${process.env.REACT_APP_STAGE || ""}`;
    if (!BUCKET) {
        const m = "S3バケット名が未設定です。REACT_APP_BUCKET もしくは REACT_APP_STAGE を確認してください。";
        throw new Error(m);
    }

    if (!authSession || !authSession.credentials) {
        const m = "AWS認証情報を取得できません。ログイン済みか、Identity Poolの設定を確認してください。";
        throw new Error(m);
    }

    const key = [
        powertrain,
        config.project_id,
        config.destination_id,
        config.lot_id,
        config.phase_id,
        config.unit_id,
        config.calculation_id,
        ...(gear_id ? [gear_id] : []),
        `${phenomenon_id}-${drive_mode_id}.xlsx`,
    ]
        .filter(Boolean)
        .join("/");

    const client = new S3Client({
        region: "ap-northeast-1",
        credentials: authSession.credentials,
    });

    try {
        const bytes = new Uint8Array(await file.arrayBuffer());

        const put = new PutObjectCommand({
            Bucket: BUCKET,
            Key: key,
            Body: bytes,
            ContentType: file.type || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const out = await client.send(put);
        return { bucket: BUCKET, path: key, etag: out.ETag };
    } catch (err: any) {
        const msg =
            err?.name || err?.message
                ? `${err.name ?? "S3UploadError"}: ${err.message ?? ""}`
                : String(err);
        const m = `S3へのアップロードに失敗しました。${msg}（権限/IAMロール、CORS、リージョン、バケット名を確認）`;
        throw new Error(m);
    }
};
